import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../shared/constants';
import { Observable } from 'rxjs';
import {
	SalonMappingGridDataReturnModel,
	SalonMappingToMasterGridResultModel,
	SalonMasterWithReportRegionListGridDataReturnModel,
	SalonMappingActionResultModel,
	SalonMappingOption
} from '../shared/models/salon-mapping.model';
import { LoadOptions, HeaderFilterOption } from '../shared/models/shared.model';
import { HeaderFilterData } from '../shared/models/product.model';

@Injectable({providedIn: 'root'})
export class SalonMappingService {
	private token = localStorage.getItem('token');
	private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

	private url = Constants.devServerEndpoint + 'api/salonmapping';

	constructor(private httpClient: HttpClient) { }

	public getSalonMappingGrid(param: LoadOptions): Observable<SalonMappingGridDataReturnModel> {
		return this.httpClient
			.post<SalonMappingGridDataReturnModel>(
				this.url + `/getSalonMappingGrid`, param,
				{ headers: this.headers }
			);
	}

	public getSalonMappingToMasterGrid(salonMappingId: number, param: LoadOptions): Observable<SalonMappingToMasterGridResultModel> {
		return this.httpClient
			.post<SalonMappingToMasterGridResultModel>(
				this.url + `/getSalonMappingToMasterGrid/${salonMappingId}`, param,
				{ headers: this.headers }
			);
	}

	public getSalonMasterWithReportRegionListGrid(param: LoadOptions): Observable<SalonMasterWithReportRegionListGridDataReturnModel> {
		return this.httpClient
			.post<SalonMasterWithReportRegionListGridDataReturnModel>(
				this.url + `/getSalonMasterWithReportRegionListGrid`, param,
				{ headers: this.headers }
			);
	}

	public mappingAction(mappingData: SalonMappingOption): Observable<boolean> {
		return this.httpClient
			.post<boolean>(
				this.url + '/mappingAction', mappingData,
				{ headers: this.headers }
			);
	}

	public getHeaderFiltersSalonMapping(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
		return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersSalonMapping`, param,
				{ headers: this.headers }
			);
	}

	public getHeaderFiltersSalonMappingToMaster(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
		return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersSalonMappingToMaster`, param,
				{ headers: this.headers }
			);
	}

	public getHeaderFiltersSalonMaster(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
		return this.httpClient
			.post<HeaderFilterData[]>(
				this.url + `/getHeaderFiltersSalonMaster`, param,
				{ headers: this.headers }
			);
	}
}